import React from 'react'
export default class ShippingLines extends React.Component {

  constructor(props) {
    super(props)
  }

  addressKey(shippingLine) {
    const getField = (key) => {
      let value = shippingLine[key]
      if (typeof value != "undefined" && value != null) return value
      else return ""
    }
    let address = `${getField("company")} ${getField("address1")} ${getField("address2")} ${getField("city")} ${getField("country")} ${getField("zip")}`
    return address.replace(/[\ \n]/g, "")
  }

  render() {
    const border = "1px solid #ddd"
    let sli = this.props.summary_line_item
    let oam = this.props.order_address_map
    let on = this.props.order_notes
    let shippingLines = []
    for (let j = 0; j < sli.order_ids.length; j++) {
      let shipping = oam[sli.order_ids[j]]
      if (shipping) {
        shippingLines.push({
          key: `${sli.sku}${sli.order_ids[j]}`,
          name: shipping.first_name + " " + shipping.last_name,
          company: shipping.company,
          address1: shipping.address1,
          address2: shipping.address2,
          city: shipping.city,
          province_country: (shipping.province_code ? shipping.province_code : "") + " " + shipping.country,
          zip: shipping.zip,
          quantity: sli.count_in_order_map[sli.order_ids[j]],
          order_name: on[sli.order_ids[j]].name
        })
      }
    }

    // sort the shipping lines by address
    shippingLines.sort((a, b) => {
      let aAddress = this.addressKey(a)
      let bAddress = this.addressKey(b)

      console.log(aAddress, bAddress, aAddress.localeCompare(bAddress))

      return aAddress.localeCompare(bAddress)
    })

    let addressQuantityMap = {}
    for (let j = 0; j < shippingLines.length; j++) {
      let shippingLine = shippingLines[j]
      let key = this.addressKey(shippingLine)
      let quantityForAddress = addressQuantityMap[key] ? addressQuantityMap[key].quantity : 0
      let rowSpanForAddress = addressQuantityMap[key] ? addressQuantityMap[key].rowSpan : 1
      addressQuantityMap[key] = {
        quantity: quantityForAddress + shippingLine.quantity,
        rowSpan: rowSpanForAddress + 1,
      }
    }

    const getAndUpdateAddressQuantity = (shippingLine) => {
      let key = this.addressKey(shippingLine)
      let addressQuantity = { rowSpan: addressQuantityMap[key].rowSpan, quantity: addressQuantityMap[key].quantity }
      addressQuantityMap[key].rowSpan = 0
      return addressQuantity
    }

    let shippingLinesJsx = []
    for (let j = 0; j < shippingLines.length; j++) {
      let shippingLine = shippingLines[j]
      let addressQuantity = getAndUpdateAddressQuantity(shippingLine)
      shippingLinesJsx.push([
        <tr key={shippingLine.key}>
          <td style={{ borderTop: border }}>{shippingLine.name}</td>
          <td style={{ borderTop: border }}>{shippingLine.company}</td>
          <td style={{ borderTop: border }}>{shippingLine.address1}</td>
          <td style={{ borderTop: border }}>{shippingLine.address2}</td>
          <td style={{ borderTop: border }}>{shippingLine.city}</td>
          <td style={{ borderTop: border }}>{shippingLine.province_country}</td>
          <td style={{ borderTop: border, borderRight: border }}>{shippingLine.zip}</td>
          <td style={{ borderTop: border, borderRight: border, textAlign: "center" }}>{shippingLine.quantity}</td>
          <td style={{ borderTop: border, borderRight: border, textAlign: "center" }}>{shippingLine.order_name}</td>
          {addressQuantity.rowSpan > 0 &&
            <td style={{ borderTop: border, textAlign: "center", rowSpan: addressQuantity.rowSpan }}>{addressQuantity.quantity}</td>
          }
        </tr>
      ])
    }

    return <table className="shipping-lines" style={{ marginBottom: "2rem" }}>
      <tbody>
        <tr>
          <th colSpan="7" style={{ borderRight: border, fontWeight: "lighter" }}>Address</th>
          <th style={{ borderRight: border, fontWeight: "lighter" }}>Quantity</th>
          <th style={{ borderRight: border, fontWeight: "lighter" }}>Order</th>
          <th style={{ fontWeight: "lighter" }}>Loc. Total</th>
        </tr>
        {shippingLinesJsx}
      </tbody>
    </table>
  }
}